import { CandidateApplyStatusModel, ICandidateApplyStatus, ICandidateApplyStatusBlock } from "@core/models";

export const statusMock = new CandidateApplyStatusModel({
  [ICandidateApplyStatus.title]: "Bienvenue chez Extracadabra !",
  [ICandidateApplyStatus.content]: "Pour aller plus loin et trouver le job de tes r\u00eaves :",
  [ICandidateApplyStatus.isAE]: false,
  [ICandidateApplyStatus.type]: "success",
  [ICandidateApplyStatus.blocks]: [
    {
      [ICandidateApplyStatusBlock.number]: 1,
      [ICandidateApplyStatusBlock.title]: "Finalise ton profil",
      [ICandidateApplyStatusBlock.content]: "et ajoute tes formations, tes comp\u00e9tences ou les langues parl\u00e9es",
      [ICandidateApplyStatusBlock.isAppBlock]: false,
    },
    {
      [ICandidateApplyStatusBlock.number]: 2,
      [ICandidateApplyStatusBlock.title]: "T\u00e9l\u00e9charge notre app",
      [ICandidateApplyStatusBlock.isAppBlock]: true,
    },
    {
      [ICandidateApplyStatusBlock.number]: 3,
      [ICandidateApplyStatusBlock.title]: "Re\u00e7ois nos offres et postule",
      [ICandidateApplyStatusBlock.content]: "Des centaines d'annonces extras et CDI par jour.",
      [ICandidateApplyStatusBlock.isAppBlock]: false,
    },
  ],
});

export const statusCandidateMock = new CandidateApplyStatusModel({
  [ICandidateApplyStatus.title]: "Nous avons bien pris en compte ta candidature !",
  [ICandidateApplyStatus.content]: "Pour la valider, le statut d'auto entrepreneur est n\u00e9cessaire.",
  [ICandidateApplyStatus.isAE]: true,
  [ICandidateApplyStatus.type]: "success",
  [ICandidateApplyStatus.blocks]: [
    {
      [ICandidateApplyStatusBlock.number]: 1,
      [ICandidateApplyStatusBlock.title]: "T\u00e9l\u00e9charge notre app",
      [ICandidateApplyStatusBlock.isAppBlock]: true,
    },
    {
      [ICandidateApplyStatusBlock.number]: 2,
      [ICandidateApplyStatusBlock.title]: "Cr\u00e9e ton statut auto-entrepreneur",
      [ICandidateApplyStatusBlock.isAppBlock]: false,
      [ICandidateApplyStatusBlock.actionLabel]: "Suis notre guide",
      [ICandidateApplyStatusBlock.actionLink]: "https://www.extracadabra.com/",
    },
    {
      [ICandidateApplyStatusBlock.number]: 3,
      [ICandidateApplyStatusBlock.title]: "Re\u00e7ois nos offres et postule",
      [ICandidateApplyStatusBlock.isAppBlock]: false,
      [ICandidateApplyStatusBlock.actionLabel]: "Comment faire ?",
      [ICandidateApplyStatusBlock.actionLink]: "https://www.extracadabra.com/",
    },
  ],
});

export const statusWarningMock = new CandidateApplyStatusModel({
  [ICandidateApplyStatus.title]: "Ta candidature ne peut pas aboutir !",
  [ICandidateApplyStatus.content]: "Tu n'as pas la compétence nécessaire",
  [ICandidateApplyStatus.isAE]: false,
  [ICandidateApplyStatus.type]: "warning",
  [ICandidateApplyStatus.blocks]: [
    {
      [ICandidateApplyStatusBlock.number]: 1,
      [ICandidateApplyStatusBlock.title]: "T\u00e9l\u00e9charge notre app",
      [ICandidateApplyStatusBlock.isAppBlock]: true,
    },
    {
      [ICandidateApplyStatusBlock.number]: 2,
      [ICandidateApplyStatusBlock.title]: "Re\u00e7ois nos offres et postule",
      [ICandidateApplyStatusBlock.isAppBlock]: false,
      [ICandidateApplyStatusBlock.actionLabel]: "Comment faire ?",
      [ICandidateApplyStatusBlock.actionLink]: "https://www.extracadabra.com/",
    },
  ],
});
